import { Component, ChangeDetectorRef } from '@angular/core'

import { IonicPage, NavController, NavParams, LoadingController, Loading, AlertController } from 'ionic-angular'

import { ModalController } from 'ionic-angular'

import { AuthProvider } from '../../providers/auth/auth'
import { DeviceProvider } from '../../providers/device/device'

//import {MessageShowPage}from '../../pages/message-show/message-show';
import { LoginPage } from '../../pages/login/login'
import { HeatingConsumptionPage } from '../../pages/heating-consumption/heating-consumption'
import { MessageCreateReportPage } from '../../pages/message-create-report/message-create-report'
import { SettlementModalPage } from '../../pages/settlement-modal/settlement-modal'

import { Condominium, Message, DeviceCache, Device, MessageReceiverType } from '../../models/models'
import { MessageProvider } from '../../providers/message/message'
import { TimetableModalPage } from '../timetable-modal/timetable-modal'


@IonicPage()
@Component({
	selector: 'page-dashboard',
	templateUrl: 'dashboard.html',
})
export class DashboardPage {

	public get device(): Device {
		return DeviceProvider.actual
	}

	loading: Loading

	datetime: Date = null;
	pin: string = null;
	/**
	*/
	private _isMessagesLoading: boolean = false;
	public get isMessagesLoading(): boolean {
		return this._isMessagesLoading
	};
	public set isMessagesLoading(value: boolean) {
		this._isMessagesLoading = value
		if(this.isChangeDetected)
			this.changeDetector.detectChanges()
	}

	/**
	*/
	private _isCondominiumLoading: boolean = true;
	public get isCondominiumLoading(): boolean {
		return this._isCondominiumLoading
	};
	public set isCondominiumLoading(value: boolean) {
		this._isCondominiumLoading = value
		if(this.isChangeDetected)
			this.changeDetector.detectChanges()
	}


	private isChangeDetected = false;
	/*
	Timer polling nuovi messaggi al condominio
	*/
	messagesClock: any = null;
	clock: any

	constructor(
		public alertCtrl: AlertController,
		public auth: AuthProvider,
		private changeDetector: ChangeDetectorRef,
		public devices: DeviceProvider,
		//private documentViewer: DocumentViewer,
		public loadingCtrl: LoadingController,
		public messages: MessageProvider,
		public modalCtrl: ModalController,
		public navCtrl: NavController,
		public navParams: NavParams
	) {
		console.debug('[new DashboardPage()]')
	}

	get condominium(): Condominium {
		return DeviceProvider.actual.condominium
	}

	/**
	Avvia polling messaggi e orologio
	*/
	ionViewDidLoad() {
		let self = this

		this.clock = setInterval(function() {
			try {
				self.datetime = new Date()//aggiorna data e ora
				if(this.isChangeDetected)
					self.changeDetector.detectChanges()
			} catch(e) {
				//se è già dismesso lancia eccezione, ignora
				console.error('Errore: ' + e)
			}
		}, 1000)

		console.debug('[DashboardPage.ionViewDidLoad()] Visualizzazione bacheca, ricarico i dati del dispositivo..')
		this.refresh()/*
		FIX già lo fa internamente
		.then(() => {
			self.refreshMessages()
		})*/

		/*polling messaggi*/
		if(self.messagesClock) {//se sta leggendo i messagi smette
			console.warn('Bacheca già controllando i messaggi, non registro il polling')
			/*
			clearInterval(self.messagesClock);
			self.messagesClock = null;
			self.isMessagesLoading = false;
			*/
		} else {
			console.debug('[DashboardPage,ionViewDidLoad] Registro controllo messaggi condominio per bacheca...')
			self.messagesClock = setInterval(() => {
				console.debug('[DashboardPage.ionViewDidLoad().messageClock] Poll messaggi bacheca...')
				self.refreshMessages()
			}, 60000)
		}
	}

	/**
	Ogni volta che torna alla bacheca disconnette l'utente
	*/
	ionViewWillEnter() {
		if(this.auth.isAuth) {
			console.log('Ritorno alla bacheca pubblica: Logout')
			this.auth.logout()
		}
	}

	ionViewDidEnter() {
		//NOTE i cambiamenti sino visibili solo dopo che è visualizzato, altrimenti producono eccezione
		this.isChangeDetected = true
	}

	ionViewWillLeave() {
		this.isChangeDetected = false
	}

	/**
	Ferma polling messaggi e orologio
	*/
	ionViewWillUnload() {
		if(this.messagesClock) {
			clearInterval(this.messagesClock)
		}
		if(this.clock) {
			clearInterval(this.clock)
		}
	}


	/*
	Visualizza regolamento di condominio
	*/
	showSettlement() {
		let settlementModal = this.modalCtrl.create(
			SettlementModalPage,
			{
				condominium: DeviceProvider.actual.condominium
				//url:"http://ethicsoft.it/web/tools/lorem-ipsium-1.pdf"
			}
		)
		settlementModal.present()
	}
	showTimetable() {
		let timetableModal = this.modalCtrl.create(
			TimetableModalPage,
			{
				condominium: DeviceProvider.actual.condominium
				//url:"http://ethicsoft.it/web/tools/lorem-ipsium-1.pdf"
			}
		)
		timetableModal.present()
	}

	/*
	Invia segnalazione
	*/
	goToMessageCreateReport() {
		console.info('[DashboardPage.goToMessageCreateReport()] Login per inviare un report')
		this.navCtrl.push(LoginPage, {
			next: MessageCreateReportPage,
			nextNavParams: { condominium: DeviceProvider.actual.condominium },
			nextPush: true,
			type: 'pin',
			isTypeForced: true
		})
	}
	/*
	Visualizza consumi
	*/
	goToHeatingConsumption() {
		console.info('[DashboardPage.goToHeatingConsumption()] Login per visualizzare i consumi')
		this.navCtrl.push(LoginPage, {
			next: HeatingConsumptionPage,
			nextNavParams: { condominium: DeviceProvider.actual.condominium },
			nextPush: true,
			type: 'pin'
		})
	}


	/*
	Ricarica i dati da remoto, con i messaggi a cascata
	*/
	private refresh() {
		console.debug('[DashboardPage.refresh()]')
		let self = this
		/*
		Ricarica il dispositivo con il condominio associato
		*/
		this.isCondominiumLoading = true
		let reloaded = this.devices.getActual(null, DeviceCache.FALLBACK).then((device) => {
			console.debug('Dispositivo ricaricato', device)

			self.isCondominiumLoading = false

			self.refreshMessages()
		}).catch(error => {
			console.error('Errore ricaricando i dati del dispositivo corrente:', error)
			self.isCondominiumLoading = false
		})
		return reloaded
	}


	refreshMessages() {
		if(this.isMessagesLoading) {
			console.warn('[DashboardPage.refreshMessages()] Caricamento multiplo simultaneo messaggi bacheca, annullo il secondo refresh')
			return
		}
		this.isMessagesLoading = true

		let retained = 7//messaggi visualizzati
		let self = this
		console.debug('[DashboardPage.refreshMessages()] Richiesta nuovi messaggi per condominio da visualizzare su bacheca..')

		try {
			let lastMessage: Message = null
			let hasPreviousMessages = this.condominium.messages && this.condominium.messages.length > 0
			if(hasPreviousMessages) {
				lastMessage = this.condominium.messages.reduce((min, actual) => actual.id > min.id ? actual : min, this.condominium.messages[0])//l'ultimo
				console.debug('[DashboardPage.refreshMessages()] Trovati messaggi condominio già ricevuti, ultimo ricevuto:', lastMessage, this.condominium.messages)
			}

			this.messages.indexIncoming(this.condominium.id, MessageReceiverType.CONDOMINIUM, [], 10, lastMessage).then((messages: Message[]) => {
				console.debug('[DashboardPage.refreshMessages()] Recuperati nuovi messaggi in arrivo:', messages)
				for(let message of messages) {
					message.receiver = self.condominium
				}

				//se ha altre chiamate parallele riesegue il controllo
				let hasPreviousMessages = self.condominium.messages && self.condominium.messages.length > 0
				if(hasPreviousMessages) {
					messages = messages.concat(self.condominium.messages)
				}

				//FIX 2021 elimina duplicati
				let id_map = new Map()
				let unique_messages = []
				for(const message of messages) {
					if(!id_map.has(message.id)) {
						id_map.set(message.id, true)
						unique_messages.push(message)
					}
				}

				var today = new Date().toISOString().split('T')[0]

				//FIX 2021 sort prima di trim
				unique_messages.sort((m1, m2) => {//sort in ordine inverso considerando le priorità

					if(m1.pin_until && m1.pin_until >= today) {
						if(m2.pin_until && m2.pin_until >= today) {
							//entrambi hanno pin attivo, confronto i pin
							if(m2.pin_until > m1.pin_until) return 1
							if(m2.pin_until < m1.pin_until) return -1
							return m2.id - m1.id
						}
						return -1//vince m1
					}

					if(m2.pin_until && m2.pin_until >= today) {//solo 2 ha pin attivo
						return 1//vince m2
					}
					//nessuno ha pin attivo
					return m2.id - m1.id
				})

				//infine elimina quelli in fondo se necessario
				if(unique_messages.length > retained) {
					unique_messages.splice(retained - 1, unique_messages.length - retained)//Mantiene solo gli ultimi retained
				}

				self.condominium.messages = unique_messages

				self.isMessagesLoading = false
			}).catch(error => {
				console.error("Errore recuperando i messaggi dell'utente", error)
				self.isMessagesLoading = false
			})
		} catch(e) {
			//se è già dismesso lancia eccezione, ignora
			console.error('Errore aggiornandi i messaggi: ' + e)
			this.isMessagesLoading = false
		}
	}

	showSuccess(text) {
		this.loading.dismiss()

		let successAlert = this.alertCtrl.create({
			title: 'Successo',
			subTitle: text,
			buttons: ['OK']
		})
		successAlert.present()
	}

	showError(text) {
		this.loading.dismiss()

		let errorAlert = this.alertCtrl.create({
			title: 'Errore',
			subTitle: text,
			cssClass: 'danger',
			buttons: ['OK']
		})
		errorAlert.present()
	}
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/dashboard.ts